"use client";

import { getAssetImage } from "@/service/image/asset";
import { usePathname } from "next/navigation";

export const Favicons = () => {
  const pathname = usePathname();

  return (
    <>
      <link rel="icon" href={getAssetImage("/club/favicon.ico")} sizes="any" />
      <link rel="apple-touch-icon" href={getAssetImage("/club/favicon.png")} />
    </>
  );
};
